import { Injectable, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SecureGuard } from 'src/app/core/guards/secure.guard';
import { ProfileComponent } from './profile.component';
import { AuthGuard } from 'src/app/core/guards/auth.guard';

const profileChildRoutes: Routes = [
  {
    path: 'info',
    loadChildren: () =>
      import('./profile-info/profile-info.module').then(
        (m) => m.ProfileInfoModule,
      ),
  },
  {
    path: 'edit',
    loadChildren: () =>
      import('./edit-profile/edit-profile.module').then(
        (m) => m.EditProfileModule,
      ),
  },
];

const routes: Routes = [
  {
    path: 'profile',
    redirectTo: '/profile/info',
    pathMatch: 'full',
  },
  {
    path: 'profile',
    component: ProfileComponent,
    canActivate: [AuthGuard],
    children: [...profileChildRoutes], // Spread the child routes here
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ProfileRoutingModule {}
